import { EventManager, Events } from "@events";
import { ref } from "vue";

function useConnectionState(rtcId) {
  const eventEmitter = EventManager.getEventEmitter(rtcId);

  const callStartedTimeStamp = new Date().getTime();

  const lastConnectionLog = ref("not_set");
  const connectionLogHistory = ref(["not_set"]);

  const addConnectionLog = (newState) => {
    connectionLogHistory.value.push(newState);
    lastConnectionLog.value = newState;
    eventEmitter.emit(Events.ConnectionStateChanged, newState);
    logConnectionStateChange(newState);
  };

  return {
    connectionLogHistory,
    lastConnectionLog,
    addConnectionLog,
  };

  function logConnectionStateChange(newState) {
    const diff = new Date().getTime() - callStartedTimeStamp;

    const containsFailWords = (str) =>
      str.toLowerCase().includes("failed") ||
      str.toLowerCase().includes("error") ||
      str.toLowerCase().includes("fail") ||
      str.toLowerCase().includes("disconnected") ||
      str.toLowerCase().includes("closed") ||
      str.toLowerCase().includes("timeout") ||
      str.toLowerCase().includes("unavailable") ||
      str.toLowerCase().includes("not_found");

    let color = "";
    const isError = containsFailWords(newState);
    if (isError) {
      color =
        "background-color: red; color: white;font-weight: bold; padding: 2px 4px; border-radius: 4px;";
    } else {
      color =
        "background-color: green; color: white;font-weight: bold; padding: 2px 4px; border-radius: 4px;";
    }
    
    console[isError ? "error" : "log"](
      `%cCall State Changed%c %c${newState}%c -  ${rtcId} - Call Time: ${diff}ms`,
      "background-color: yellow;color: black;font-weight: bold; padding: 1px 4px; border-radius: 4px; ",
      "",
      color,
      ""
    );
  }
}

export { useConnectionState };
